import React from "react";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useUserStore } from "../_store/userStore";

const ProtectedRoute = ({ children }) => {
  const userData = useUserStore((state) => state.userData);
  const location = useLocation();
  const params = useSearchParams();

  // console.log("params", params);

  // If user is not logged in, redirect to login with the current location
  if (!userData || !userData._id) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If children are provided, render them; otherwise use Outlet for nested routes
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
